export enum UserExistenceStatus {
  NOT_EXISTS = 'NOT_EXISTS',
  EXISTS = 'EXISTS'
}
